export default "__VITE_ASSET__Chc9m$Hw__"